const DiscountTypes = Object.freeze({
  FIXED: 1,
  PERCENTAGE: 2,
});

export default DiscountTypes;
